import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { useRouteParams } from '../hooks/useRouteParams';
import { queryKeys } from './queryKeys';

const longTermForm = ({ clientId }) => ({ body }) => {
  return authFetch(
    urlWithParams('/Consumer/AutomatedAccountsUpdate/LongTerm', {
      clientId,
    }),
    { method: 'POST', ...httpBodyOptions(body, true) },
  );
};

export const useLongTermMutation = () => {
  const { clientId } = useRouteParams();

  const queryClient = useQueryClient();

  return useMutation(longTermForm({ clientId }), {
    onSuccess() {
      queryClient.invalidateQueries(queryKeys.automatedAccounts(clientId));
    },
  });
};
